import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { HomeIcon } from "src/components/ui-icons/menu";
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import Select from "../../ui/select";
import { getFilters, getFetchingStatusFilters } from '../../store/filters/selectors';
import { fetchFiltersRequestVPO } from '../../store/filters/filters';
import { transformTitle } from 'src/pages/DashboardPage/gop/utils/utils';
import { fetchActionByIdVPO } from '../../api/api';

type MainHeadProps = {
  group: { [key: string]: string | number } | null;
  factory: { [key: string]: string | number };
  user?: unknown;
  onGroupChange: (value: { [key: string]: string | number }) => void;
  onFactoryChange: (value: { [key: string]: string | number }) => void;
  setMonth: React.Dispatch<React.SetStateAction<number | null>>;
  setYear: React.Dispatch<React.SetStateAction<number | null>>;
  columns?: any[];
  onColumnChange?: (value: { [key: string]: string | number }) => void;
  hideSelects?: boolean;
}

function MainHead({ group, factory, user, onGroupChange, onFactoryChange, setMonth, setYear, columns, onColumnChange, hideSelects }: MainHeadProps) {

  const dispatch = useAppDispatch();
  const groups = useAppSelector(getFilters).filter((group) => group.title !== 'SOP');
  const loading = useAppSelector(getFetchingStatusFilters);
  const loadingUser = useAppSelector((state) => state.users.statusCurrent);

  const prevLoadingUser = useRef<string | null>(null);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    dispatch(fetchFiltersRequestVPO());
  }, [dispatch]);

  console.log('groupsVpo', groups);

  //! ставлю фильтры из карточки VPO, беру из url если есть (для открытия модалки при переходе по ссылке)
  useEffect(() => {
    const actionCardId = searchParams.get('actionCardVPO');

    if (actionCardId && !loading && groups.length > 0 && !group && loadingUser === 'SUCCESS') {
      fetchActionByIdVPO(Number(actionCardId)).then(card => {

        if (card.month && card.year) {
          setMonth(card.month);
          setYear(card.year);
        }

        if (card.column?.id && columns && onColumnChange) {
          const targetColumn = columns.find((col: any) => col.id === card.column.id);
          if (targetColumn) {
            onColumnChange(targetColumn);
          }
        }

        const targetGroup: any = card.group?.id
          ? groups.find((grp: any) => grp.id === card.group.id)
          : null;

        if (targetGroup) {
          const foundFactory = targetGroup.factories?.find((f: any) => f.id === card.factory?.id);
          onGroupChange(transformTitle(targetGroup));
          if (foundFactory) {
            onFactoryChange(transformTitle(foundFactory));
          }
        } else {
          for (const grp of groups) {
            const foundFactory = grp.factories?.find((f: any) => f.id === card.factory?.id);
            if (foundFactory) {
              onGroupChange(transformTitle(grp));
              onFactoryChange(transformTitle(foundFactory));
              break;
            }
          }
        }
      }).catch(err => console.error('Ошибка загрузки карточки VPO:', err));
      return;
    }

    // Дефолтные фильтры если нет actionCardVPO
    if (!loading && groups.length > 0 && !group && prevLoadingUser.current === 'SUCCESS' && loadingUser === 'SUCCESS') {

      const defaultGroup = transformTitle(groups[0]);
      const defaultFactory = transformTitle(defaultGroup.factories?.[0]) || null;

      // Устанавливаем по дефолту группу и завод пользователя
      let currentGroup = null;
      let currentFactory = null;

      if (user.infoVPO.directoryTitle.length > 0) {
        currentGroup = groups.find((group) => group.title === user.infoVPO.directoryTitle[0]);
      }

      if (user.infoVPO.factory.length > 0 && currentGroup) {
        currentFactory = currentGroup.factories.find((factory) => factory.title === user.infoVPO.factory[0].factoryTitle);
      }

      currentGroup ? onGroupChange(transformTitle(currentGroup)) : onGroupChange(defaultGroup);
      currentFactory ? onFactoryChange(transformTitle(currentFactory)) : onFactoryChange(defaultFactory);
    }

    prevLoadingUser.current = loadingUser;
  }, [groups, loading, group, user, loadingUser, searchParams]);

  const dataGroups = groups.map(transformTitle);

  console.log('dataGroups', dataGroups);

  const dataFactories = (group?.factories ?? []).map(transformTitle);

  const handleSelectChangeGroup = (newValue: { [key: string]: string | number }) => {
    const currentId = newValue.id;
    const currentGroup = groups.find((group) => group.id === currentId);
    onGroupChange(transformTitle(currentGroup));
    onFactoryChange(transformTitle(currentGroup.factories?.[0]) || null);
  };

  const handleSelectChangeFactory = (newValue: { [key: string]: string | number }) => {
    onFactoryChange(newValue);
  };

  return (
    <div className="px-7.5 py-4 border-b flex items-center gap-2">
      <HomeIcon />
      <p className="mr-auto">Главная</p>
      {!loading && !hideSelects && (
        <>
          <Select selected={group} data={dataGroups} onChange={handleSelectChangeGroup} />
          <Select selected={factory} data={dataFactories} onChange={handleSelectChangeFactory} />
        </>
      )}
    </div>
  );
}

export default MainHead;
